var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "9px",
    viewBox: "0 0 20 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---SFY---Personalise",
    transform: "translate(-480.000000, -687.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(119.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.9028,44 C373.8236,44 371.5446,45.1847273 370,46.9816591 C368.455,45.1847273 366.1762,44 364.0972,44 C362.1164,44 360,45.1820682 360,48.5 C360,51.8179318 362.1164,52.9997955 364.0972,53 L364.0972,53 C366.1766,53 368.455,51.8154773 370,50.0189545 C371.5446,51.8154773 373.8234,53 375.9024,53 C377.8836,53 380,51.8179318 380,48.5 C380,45.1820682 377.8836,44 375.9028,44 Z M364.251729,51 C362.757953,51 362,50.1589334 362,48.4999053 C362,46.8414454 362.757953,46 364.251729,46 C365.903774,46 367.82217,47.027802 369,48.4999053 C367.822367,49.9720086 365.904367,51 364.251729,51 Z M375.747876,51 C374.095831,51 372.177435,49.9720086 371,48.4999053 C372.177435,47.027802 374.096226,46 375.748271,46 C377.242442,46 378,46.841256 378,48.4999053 C377.999605,50.1589334 377.242047,51 375.747876,51 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.858dbdefc4300811d48c15fb9398e142.svg";
export { ForwardRef as ReactComponent };